export default __webpack_public_path__ + "static/media/lin.b0702f8b.svg";